import { Button } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconEdit } from '@tabler/icons-react';

import { RouterOutput, trpc } from '../../../../../../services/trpc';
import { InstallerProjectEditAddressesForm } from './-installer-project-edit-addresses-form';

export function InstallerProjectEditAddressesButton({
  project,
}: {
  project: RouterOutput['projects']['get'];
}) {
  const updateAddress = trpc.projects.updateAddress.useMutation();

  const initialValues = {
    homeAddress: project.homeAddress,
    deliveryAddress: project.deliveryAddress,
    installationAddress: project.installationAddress,
    billingAddress: project.billingAddress,
  };

  const openAddDocumentModal = () => {
    modals.open({
      title: 'Modifier les adresses du projet',
      size: 'auto',
      fullScreen: true,
      children: (
        <InstallerProjectEditAddressesForm
          project={project}
          initialValues={initialValues}
          onSubmit={async values => {
            await updateAddress.mutateAsync({
              id: values.homeAddress.id!,
              ...values.homeAddress,
            });
            await updateAddress.mutateAsync({
              id: values.deliveryAddress.id!,
              ...values.deliveryAddress,
            });
            await updateAddress.mutateAsync({
              id: values.installationAddress.id!,
              ...values.installationAddress,
            });
            await updateAddress.mutateAsync({
              id: values.billingAddress.id!,
              ...values.billingAddress,
            });
            modals.closeAll();
            notifications.show({
              title: 'Adresses modifiées avec succès',
              message: '',
              color: 'green',
            });
          }}
        />
      ),
    });
  };

  return (
    <Button
      onClick={openAddDocumentModal}
      leftSection={<IconEdit size={16} />}
      variant="outline"
    >
      Modifier
    </Button>
  );
}
